import { Button, Modal } from 'flowbite-react';
import { useState } from 'react';

import { ILead } from '../../../../types/lead.type';

type Props = {
  lead: ILead
  openEditExistLead: (leadId: string) => void
}

export default function ModalConfirmEdit(props: Props) {

  const [show, setShow] = useState(true);
  return (
    <Modal
      className='relative dark:text-black'
      show={show}
      onClose={() => setShow(false)}
    >
      <Modal.Header>
        <h2 className="dark:text-black text-2xl font-semibold mb-4">
          Lead já cadastrado {props.lead.technicalConsultant && `pelo consultor: ${props.lead.technicalConsultant}`}, deseja prosseguir com o cadastro?
        </h2>
      </Modal.Header>

      <div className='flex justify-center mt-4 mb-4'>
        <Button
          color="success"
          className="text-white bg-greenPrimary hover:bg-green-700 px-6 py-2 mx-2"
          onClick={() => {
            setShow(false);
            if (props.lead._id) {
              props.openEditExistLead(props.lead._id);
            }
          }}
        >
          Sim
        </Button>

        <Button
          color="failure"
          className="text-white bg-redPrimary hover:bg-red-700 px-6 py-2 mx-2"
          onClick={() => setShow(false)}
        >
          Não
        </Button>
      </div>
    </Modal>
  );
}
